import { getFullUrl } from 'hubspot-url-utils';
import { useTranslation } from '../../../hooks/useNavConfig';
import { AccountExtraLink } from './AccountExtrasLink';
import { jsx as _jsx } from "react/jsx-runtime";
export const ProjectsLink = ({
  portalId,
  hasProjectAccess
}) => {
  const {
    t
  } = useTranslation();
  if (!hasProjectAccess) {
    return null;
  }
  return /*#__PURE__*/_jsx(AccountExtraLink, {
    id: "projects",
    link: `${getFullUrl('app')}/projects/${portalId}`,
    linkText: t('nav.tools.projects')
  });
};